import { useState, useEffect } from 'react';
import { getInvoices, getCustomers } from '../services/api';

function Invoices() {
  const [invoices, setInvoices] = useState([]);
  const [customers, setCustomers] = useState([]);

  useEffect(() => {
    loadInvoices();
    loadCustomers();
  }, []);

  const loadInvoices = async () => {
    try {
      const data = await getInvoices();
      setInvoices(data);
    } catch (error) {
      alert('Error loading invoices: ' + error.message);
    }
  };

  const loadCustomers = async () => {
    try {
      const data = await getCustomers();
      setCustomers(data);
    } catch (error) {
      console.error('Error loading customers:', error);
    }
  };

  const getCustomerName = (customerId) => {
    const customer = customers.find(c => c.id === customerId);
    return customer ? customer.name : 'Unknown';
  };

  const getStatusBadge = (status) => {
    const colors = {
      pending: '#f39c12',
      paid: '#27ae60',
      partially_paid: '#3498db',
      overdue: '#e74c3c',
      cancelled: '#95a5a6'
    };

    const displayStatus = status || 'pending';

    return (
      <span style={{
        padding: '4px 12px',
        background: colors[displayStatus] || '#95a5a6',
        color: 'white',
        borderRadius: '12px',
        fontSize: '12px',
        fontWeight: 'bold'
      }}>
        {displayStatus.replace('_', ' ').toUpperCase()}
      </span>
    );
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h1 style={{ color: '#3D1F1F' }}>Invoices</h1>
      </div>

      <div style={{
        background: 'white',
        borderRadius: '8px',
        padding: '20px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        border: '1px solid #f0f0f0'
      }}>
        {invoices.length === 0 ? (
          <p style={{ color: '#7f8c8d' }}>No invoices found. Invoices are auto-generated from delivered orders.</p>
        ) : (
          <div style={{ overflow: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: '#f8f9fa', borderBottom: '2px solid #dee2e6' }}>
                  <th style={{ padding: '12px', textAlign: 'left' }}>Invoice #</th>
                  <th style={{ padding: '12px', textAlign: 'left' }}>Customer</th>
                  <th style={{ padding: '12px', textAlign: 'left' }}>GST</th>
                  <th style={{ padding: '12px', textAlign: 'right' }}>Subtotal</th>
                  <th style={{ padding: '12px', textAlign: 'right' }}>GST Amount</th>
                  <th style={{ padding: '12px', textAlign: 'right' }}>Total</th>
                  <th style={{ padding: '12px', textAlign: 'left' }}>Status</th>
                  <th style={{ padding: '12px', textAlign: 'left' }}>Date</th>
                </tr>
              </thead>
              <tbody>
                {invoices.map(invoice => (
                  <tr key={invoice.id} style={{ borderBottom: '1px solid #dee2e6' }}>
                    <td style={{ padding: '12px', fontWeight: 'bold', color: '#C8342B' }}>
                      {invoice.invoiceNumber}
                    </td>
                    <td style={{ padding: '12px' }}>
                      {invoice.customerName || getCustomerName(invoice.customerId)}
                      {invoice.customerGST && (
                        <div style={{ fontSize: '11px', color: '#7f8c8d' }}>
                          GST: {invoice.customerGST}
                        </div>
                      )}
                    </td>
                    <td style={{ padding: '12px', fontSize: '13px' }}>
                      {invoice.totals && (
                        <div>
                          <div>CGST: ₹{invoice.totals.cgst?.toFixed(2)}</div>
                          <div>SGST: ₹{invoice.totals.sgst?.toFixed(2)}</div>
                        </div>
                      )}
                    </td>
                    <td style={{ padding: '12px', textAlign: 'right' }}>
                      ₹{invoice.totals?.subtotal?.toFixed(2) || '0.00'}
                    </td>
                    <td style={{ padding: '12px', textAlign: 'right' }}>
                      ₹{invoice.totals?.totalGst?.toFixed(2) || '0.00'}
                    </td>
                    <td style={{ padding: '12px', textAlign: 'right', fontWeight: 'bold', color: '#27ae60', fontSize: '15px' }}>
                      ₹{invoice.totals?.grandTotal?.toFixed(2) || invoice.totals?.total?.toFixed(2) || '0.00'}
                    </td>
                    <td style={{ padding: '12px' }}>{getStatusBadge(invoice.status)}</td>
                    <td style={{ padding: '12px', fontSize: '13px', color: '#7f8c8d' }}>
                      {new Date(invoice.invoiceDate).toLocaleDateString()}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default Invoices;
